/**
 * SGMembers Dashboard — theme embed
 *
 * Mounts an iframe pointing at the App Proxy path (same-origin on the shop
 * domain). Shopify proxies that request to the rewards app and signs it,
 * appending logged_in_customer_id. The app verifies the signature before
 * returning anything.
 *
 * This replaces the previous implementation, which read {{ customer.id }} from
 * a data attribute and fetched the rewards API cross-origin using that id as
 * the only credential — meaning any id could be requested by anyone.
 *
 * No customer data is handled in the theme any more; this file only manages
 * iframe sizing.
 */
(function () {
  'use strict';

  var ALLOWED_MESSAGE_TYPE = 'sgm:height';

  function initDashboard(container) {
    var proxyPath = container.getAttribute('data-proxy-path') || '/apps/loyalty';
    var minHeight = parseInt(container.getAttribute('data-min-height'), 10) || 800;

    // Only ever a same-origin, root-relative path. Guards against a mistyped
    // absolute URL in the theme editor turning this into an open frame.
    if (proxyPath.charAt(0) !== '/' || proxyPath.charAt(1) === '/') {
      container.textContent = 'Dashboard is misconfigured: app proxy path must start with "/".';
      return;
    }

    var iframe = document.createElement('iframe');
    iframe.src = proxyPath;
    iframe.title = 'Loyalty dashboard';
    iframe.loading = 'lazy';
    iframe.setAttribute('scrolling', 'no');
    iframe.style.width = '100%';
    iframe.style.minHeight = minHeight + 'px';
    iframe.style.border = '0';
    iframe.style.display = 'block';
    iframe.style.overflow = 'hidden';
    iframe.style.transition = 'height 180ms ease';

    container.appendChild(iframe);

    // The embedded app posts its content height so the iframe can grow with
    // the content instead of showing an inner scrollbar.
    window.addEventListener('message', function (event) {
      // Same-origin because the proxy serves it from the shop domain.
      if (event.origin !== window.location.origin) return;
      if (!event.data || event.data.type !== ALLOWED_MESSAGE_TYPE) return;

      var height = parseInt(event.data.height, 10);
      if (!height || height < 200 || height > 20000) return;

      iframe.style.height = height + 'px';
      iframe.style.minHeight = '0';
    });
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-sgm-dashboard]');
    for (var i = 0; i < nodes.length; i++) initDashboard(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify theme editor re-renders sections without a full page load.
  document.addEventListener('shopify:section:load', function (event) {
    var nodes = event.target.querySelectorAll('[data-sgm-dashboard]');
    for (var i = 0; i < nodes.length; i++) initDashboard(nodes[i]);
  });
})();